import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../../../localization/i18n';
import * as rk from '../../../../localization/resourceKeys';
import styles from './MyVWMarketingBanner.module.scss';
import mbStyles from './MarketingBanner.module.scss';
import { WELLSFARGOURL } from '../../../../constants/myVW';
import { MYVW_WELLS_FARGO_URL_CLICKED } from '../../../../constants/BusinessSplunkEvent';
import { SessionContext } from '../../../../context/sessionContext';
import Logger from '../../../../logger';

interface MyVWMarketingBannerProps {
  styled?: boolean;
}

export const MyVWMarketingBanner: React.FC<MyVWMarketingBannerProps> = ({ styled = false }) => {
  const sessionContext = useContext(SessionContext);
  if (!sessionContext) return null;
  const { sessionDetails } = sessionContext;

  const content = (
    <>
      <p className={styled ? `u-mb-xsmall ${styles.marketingBannerTitle}` : 'u-mb-xsmall'}>{i18n.t(rk.TEXT_MYVW_STATUS_BANNER_RIGHT_PLACE)}</p>
      <ul className={styled ? `u-mb-xsmall ${styles.marketingBannerContent}` : 'u-mb-xsmall'}>
        <li>{i18n.t(rk.TEXT_MYVW_STATUS_BANNER_LEASING)}</li>
        <li>{i18n.t(rk.TEXT_MYVW_STATUS_BANNER_FINANCING_BEFORE)}</li>
      </ul>
      <p className={styled ? `u-mb-none ${styles.marketingBannerContent}` : 'u-mb-none'}>
        <b>{i18n.t(rk.TEXT_MYVW_STATUS_BANNER_WF_QUESTION)}</b> {i18n.t(rk.TEXT_MYVW_STATUS_BANNER_WF_MANAGED)}{' '}
        <Link
          to={WELLSFARGOURL}
          className={styled ? styles.marketingBannerLink : undefined}
          target='_blank'
          rel='noopener noreferrer'
          onClick={() => Logger.info(MYVW_WELLS_FARGO_URL_CLICKED, '', sessionDetails)}
        >
          {i18n.t(rk.LINK_MYVW_STATUS_BANNER_WF_ENROLL)}
        </Link>
      </p>
    </>
  );

  if (styled) {
    return (
      <div className={`u-mb-small ${styles.marketingBannerContainer}`}>
        {content}
      </div>
    );
  }

  return (
    <div className={`c-notification__container ${mbStyles['marketing-banner']}`}>
      <div className={mbStyles['c-notification']} data-marketing-theme="2">
        <div className={mbStyles['c-notification__outer-wrap']}>
          <div className={mbStyles['c-notification__inner-wrap']}>
            {content}
          </div>
        </div>
      </div>
    </div>
  );
};
